// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-qfygc{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-bevmz{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-buits{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bhdpe{grid-column:span 3}.assets-scss-gridstyleGrid-col4-rexie{grid-column:span 4}.assets-scss-gridstyleGrid-col9-pwrrp{grid-column:span 9}.assets-scss-gridstyleGrid-col12-wsvry{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-ehoqm{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-qfygc",
	"grid": "assets-scss-gridstyleGrid-grid-bevmz",
	"col6": "assets-scss-gridstyleGrid-col6-buits",
	"col3": "assets-scss-gridstyleGrid-col3-bhdpe",
	"col4": "assets-scss-gridstyleGrid-col4-rexie",
	"col9": "assets-scss-gridstyleGrid-col9-pwrrp",
	"col12": "assets-scss-gridstyleGrid-col12-wsvry",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-ehoqm"
};
module.exports = ___CSS_LOADER_EXPORT___;
